module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper border-bottom white-bg page-heading"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-10 col-md-6 col-lg-9"
  }, [(_vm.loading) ? _c('heading-loading') : _c('h1', [_c('i', {
    staticClass: "far fa-truck m-r-sm"
  }), _vm._v(" Job " + _vm._s(_vm.job.number))])], 1), _vm._v(" "), (_vm.notLoading) ? _c('div', {
    staticClass: "col-sm-12 col-md-6 col-lg-3"
  }, [_c('p', {
    staticClass: "job-status-header",
    class: ("text-" + (_vm.job.status_class))
  }, [_vm._v(_vm._s(_vm.job.status_text))])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-237377e4"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/ShowHeading.vue
// module id = 953
// module chunks = 0